// 데모 모드 배너: 상단 알림 + 도입 문의 CTA. VITE_DEMO_BUTTON=1일 때만 마운트.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useT } from '../lib/i18n'

export function DemoBanner() {
  const { t } = useT()
  if (import.meta.env.VITE_DEMO_BUTTON !== '1') return null
  return (
    <div
      role="status"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 49,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
        padding: '0.5rem 1rem',
        fontSize: 'var(--fs-sm)',
        background: 'linear-gradient(135deg, var(--color-accent), var(--color-accent-2))',
        color: 'white',
        fontWeight: 500,
      }}
    >
      <FontAwesomeIcon icon="circle-info" aria-hidden="true" />
      <span>{t('demo.banner')}</span>
    </div>
  )
}
